// Auto-generated: imports for all layout scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/content/layouts/contact_cards/contact_cards.js';
import '../../flex/content/layouts/cta_rotating/cta_rotating.js';
import '../../flex/content/layouts/culture_scroller/culture_scroller.js';
import '../../flex/content/layouts/disciplines_list/disciplines_list.js';
import '../../flex/content/layouts/faq_tabs/faq_tabs.js';
import '../../flex/content/layouts/grid_stories/grid_stories.js';
import '../../flex/content/layouts/hero_primary/hero_primary.js';
import '../../flex/content/layouts/keuzehulp_tool/keuzehulp_tool.js';
import '../../flex/content/layouts/steps_accordion/steps_accordion.js';
import '../../flex/content/layouts/swiper_division/swiper_division.js';
import '../../flex/content/layouts/swiper_projects/swiper_projects.js';
import '../../flex/content/layouts/swiper_steps/swiper_steps.js';
import '../../flex/content/layouts/swiper_stories/swiper_stories.js';
